import { QueryClient, MutationCache } from 'react-query';
import { staffErrorMessage, StaffRequestError } from './staff-client';
export const staffQueryClient = new QueryClient({
  mutationCache: new MutationCache({ onError: error => {
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('staff-request-error', { detail: { message: staffErrorMessage(error), unauthorized: error instanceof StaffRequestError && error.status === 401 } }));
  } }),
  defaultOptions: {
    queries: { retry: false, cacheTime: 0, staleTime: 0, refetchOnWindowFocus: false, refetchOnReconnect: false },
    mutations: { retry: false },
  },
});
